/* eslint-disable */
import axios from "axios";

// -----------------------------------------------------------------------------
// County selector.
//
// The npm build shortcuts (e.g. `npm run build:kajiado`, `npm run build:meru`)
// set VUE_APP_COUNTY to the target county's slug — the block below then picks
// the matching VUE_APP_BASE_URL_<COUNTY> from .env. That lets you build for
// any county with a single command, no code edit.
//
// Backwards-compatible: if VUE_APP_COUNTY is unset, we fall back to the
// hardcoded pick (KAJIADO) so the historical workflow of editing this line
// and running plain `npm run build` still works.
// -----------------------------------------------------------------------------
const COUNTY = (process.env.VUE_APP_COUNTY || "").toUpperCase().trim();
export const base = COUNTY
    ? process.env[`VUE_APP_BASE_URL_${COUNTY}`]
    : process.env.VUE_APP_BASE_URL_TURKANA;


export const paysol =  base+"/paysol/index.php";

export const rent = base+"/rent/index.php";
export const parking =  base+"/parking/index.php";
export const trade =  base+"/trade/index.php";
export const biller =  base+"/biller/index.php";
export const authUrl =  base+"/authentication/";
export const landrate =  base+"/landrate/";

export const county_logo = base +"/logo/county_logo.png"
export const state_logo = base +"/logo/state_logo.png"
export const login_bg = base +"/logo/bg-auth-overlay.png"


export const econstruction =  base+"/econstruction/index.php";


export const signatureBaseURl =  base+"authentication/assets/signatures/";

export const plotRent =  base+"/plotrent/index.php";
export const plotRentUploads =  base+"/plotrent/uploads/";

export const landRate =  base+"/landrate/index.php";

export const fire =  base+"/fire/index.php";
export const health =  base+"/health/index.php";
export const housing =  base+"/housing/index.php";

export const liquor =  base+"/liquor/index.php";

export const education = base+"/education/index.php";

export const occupational = base+"/occupational/index.php";

export const advertising = base+"/advertising/index.php";
export const advertisingUploads = base+"/advertising/uploads/";

export const library = base+"/library/index.php";

export const uploadsLiqour = base+"/liquor/uploads/";

export const uploadTemplates = base+"/templates/";
export const park = base+"/park/index.php";



let tokenStr = 'MTVlNmJkNDE1NWZiNDBiZTZlZTVmNjMwZDg5ZmNkMTU1NTRiOTM2MDBlY2U2ZmI2YjUwNGE4MWRmOWJjYTFkZA==';
export const execute = (params, url) => {
    return axios.post(url,params,{headers: {"Authorization": `Bearer ${tokenStr}`}})
}

export const executeDownload = (params, url) => {
    return axios.post(url,params,{headers: {"Authorization": `Bearer ${tokenStr}`}, responseType: 'blob'})
}
export const execute2 = (params, url) => {
    return axios.post(url,params)
}


export const getRight = (accessRole) => {

    return true;
    // Get the string from sessionStorage and parse it into an array
 /*   const selectedRolesString = sessionStorage.getItem("selectedRoles");

    if (!selectedRolesString) {
      //  console.error("selectedRoles is not available in sessionStorage");
        return false;  // or handle the absence of selectedRoles in sessionStorage
    }

    try {
        const selectedRoles = JSON.parse(selectedRolesString);

        if (!Array.isArray(selectedRoles)) {
          //  console.error("selectedRoles is not an array");
            return false;  // or handle the case where selectedRoles is not an array
        }

        let accessRight = false;

        for (const role of selectedRoles) {
          //  console.log(`${accessRole} role: ${role.role}`);
            if (role.role === accessRole) {
                accessRight = true;
                break;  // no need to continue checking once a match is found
            }
        }

        return accessRight;
    } catch (error) {
      //  console.error("Error parsing selectedRoles:", error);
        return false;  // or handle the error appropriately
    }*/
};

